import {Select, FormGroup, Paper, TextField, Typography, FormControl, InputLabel, Button, MenuItem} from "@material-ui/core"
import { makeStyles } from '@material-ui/core/styles';
import { useState, useEffect } from "react";
//import { useDispatch, useSelector } from "react-redux";
//import {createTour, getTours} from "../actions/customer"
import { fetchSuppliers, addSupplier, fetchDest } from "../api/customerapi";
import { v4 as uuidv4 } from 'uuid';



const useStyles = makeStyles((theme) => ({
    paper: {
      marginLeft: theme.spacing(10),
      marginRight: theme.spacing(10),
      justifyContent: "center",
      backgroundColor: "#f8f8f8"
    },
    textField: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(4),
      width: theme.spacing(60),
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
    },
    headertext: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
    },
    formgroup: {
        justifyContent: "center",   
    },
    textArea: {
        marginLeft: theme.spacing(12),
        marginRight: theme.spacing(14),
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
      },
    button: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(4),
        width: theme.spacing(15),
        height: theme.spacing(6),
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
      },
  }));

const Supplierdataentry = () => {

    const classes = useStyles();
    
    const [dest, setdest]=useState([])
    const [supplierData, setsupplierData] =useState({
        supplier_name: "",
        supplier_id:0,
        supplier_destinations: "",
        supplier_address: "",
        supplier_type: "",
        supplier_bankinfo: "",
        supplier_contact: [{
            contact: 0,
            role: "",
            name: "",
            email:""
        }] 
        
    })

    const [contactData, setcontactData] =useState({
            
            role: "",
            name: "",
            email:""
    });

    const [sData, setsData]=useState(null);
    /*useEffect(() => {
        if(updatedName) setpostName(updatedName)
    }, [updatedName]);*/
    const getSuppliers = async () => {
        try{
        const data = await fetchSuppliers();
        //const custdatalistfromdb= data.data
        setsData(data.data)
    }catch(err){
        console.log(err)
      }
    }

    const getDest = async () => {
        try{
        const data = await fetchDest();
        const temp=data.data.filter(d=>"order" in d)
        setdest(temp[0].dest);
      }catch(err){
        console.log(err)
      }
      };

    useEffect(() => {
        getSuppliers()
        getDest()
    }, [])
    
    //console.log(custdatalistfromdb);
    //const updatedName= useSelector((state)=> currentID ? (state.reducerNames.find((p) => p._id ===currentID)) : null);

    const handleSubmit =async (e) => {
        try{
        e.preventDefault();
        const sortedsupplierdatalistfromdb=sData.sort((a,b) => b.supplier_id - a.supplier_id);
        const highestsupplierid=sortedsupplierdatalistfromdb[0].supplier_id;
        const newsupplierid = highestsupplierid + 1;

        const finalcontactData=(Object.keys(contactData).length && contactData.constructor === Object)? {...contactData, id:uuidv4()} :null
        const finalsupplierData= {...supplierData, supplier_id: newsupplierid, supplier_contact:[finalcontactData]};
        const addsupplierResponse= await addSupplier(finalsupplierData);
        // // dispatch(createCustomer(finalcustData));
        //console.log(finalsupplierData);
        if(addsupplierResponse.status == 200 || 201 || 202|| 203|| 204|| 205 || 206 || 207){
           alert("New supplier added with supplier id "+addsupplierResponse.data.supplier_id);
            window.location = ("/supplierdataentry/"+addsupplierResponse.data.supplier_id);
        }
        else{
            alert("Something went wrong. Contact support");
            window.location = ("/");
        }
    }catch(err){
        console.log(err)
      }
    }

    return ( 
        <Paper variant="outlined" className={classes.paper} elevation={10}>
            <Typography variant="h4" align="center" className={classes.headertext}> Add New Supplier</Typography>
            <form onSubmit={handleSubmit}>
            
            <FormGroup row className={classes.formgroup}>
                <TextField variant="standard"  required label="Name"  value={supplierData.supplier_name} className={classes.textField} onChange={(e)=> setsupplierData({...supplierData, supplier_name: e.target.value})}/>
                <TextField variant="standard"  label="Address"  value={supplierData.supplier_address} className={classes.textField} onChange={(e)=> setsupplierData({...supplierData, supplier_address: e.target.value})}/>
                
                <FormControl style={{minWidth: 480, marginTop: 16, marginRight: 32, marginLeft: 8}}>
            <InputLabel id="Type">Destination *</InputLabel>
                <Select displayEmpty required classname={classes.textField} labelId="Type" value={supplierData.supplier_destinations} onChange={(e)=> setsupplierData({...supplierData, supplier_destinations: e.target.value})}>
                {dest.map(dest => {
                    return <MenuItem value={dest}>{dest}</MenuItem>})} 
                </Select>
                </FormControl>
            
            </FormGroup>
            <FormGroup row className={classes.formgroup}>
            <FormControl style={{minWidth: 480, marginTop: 16, marginRight: 32, marginLeft: 8}}>
            <InputLabel id="Type">Supplier Type *</InputLabel>
                <Select displayEmpty required classname={classes.textField} labelId="Type" value={supplierData.supplier_type} onChange={(e)=> setsupplierData({...supplierData, supplier_type: e.target.value})}>
                    <MenuItem value={"DMC"}>DMC</MenuItem>
                    <MenuItem value={"Hotel"}>Hotel</MenuItem>
                    <MenuItem value={"Hotel Portal"}>Hotel Portal</MenuItem>
                    <MenuItem value={"Cab driver"}>Cab driver</MenuItem>
                    <MenuItem value={"Cab agency"}>Cab agency</MenuItem>
                    <MenuItem value={"Restaurant"}>Restaurant</MenuItem>
                    <MenuItem value={"Visa agency"}>Visa agency </MenuItem>
                    <MenuItem value={"Insurance agency"}>Insurance agency</MenuItem>
                    <MenuItem value={"Flight"}>Flight</MenuItem>
                    <MenuItem value={"Flight Ancilliary"}>Flight Ancilliary</MenuItem>
                    <MenuItem value={"Others"}>Others</MenuItem>
                </Select>
                </FormControl>
            </FormGroup>

            <FormGroup row className={classes.formgroup}>
                <TextField variant="outlined"  label="Bank Information"  value={supplierData.supplier_bankinfo} className={classes.textArea} fullWidth multiline rows={4} onChange={(e)=> setsupplierData({...supplierData, supplier_bankinfo: e.target.value})}/>
            </FormGroup>

            {/* {supplierData?.supplier_contact && (
            supplierData.supplier_contact.map((sup) => { 
            return <div> */}
            <FormGroup row className={classes.formgroup}>
                <TextField variant="standard"  label="Name"  required value={contactData.name} className={classes.textField} onChange={(e)=> setcontactData({...contactData, name: e.target.value})}/>
                <TextField variant="standard"  label="Contact (number)"  required value={contactData.contact} className={classes.textField} onChange={(e)=> setcontactData({...contactData, contact: e.target.value})}/>
                <TextField variant="standard"  label="Email"  value={contactData.email} className={classes.textField} onChange={(e)=> setcontactData({...contactData, email: e.target.value})}/>
            </FormGroup>
            <FormGroup row className={classes.formgroup}>
            <FormControl style={{minWidth: 480, marginTop: 16, marginRight: 32, marginLeft: 8}}>
            <InputLabel id="Role">Role *</InputLabel>
                <Select displayEmpty classname={classes.textField} labelId="Role" required value={contactData.role} onChange={(e)=> setcontactData({...contactData, role: e.target.value})}>
                    <MenuItem value={"Owner/CEO"}>Owner/CEO</MenuItem>
                    <MenuItem value={"Management"}>Management</MenuItem>
                    <MenuItem value={"Sales"}>Sales</MenuItem>
                    <MenuItem value={"Operations"}>Operations</MenuItem>
                    <MenuItem value={"Customer service"}>Customer service</MenuItem>
                    <MenuItem value={"Accounts"}>Accounts </MenuItem>
                   
                    <MenuItem value={"Others"}>Others</MenuItem>
                </Select>
                </FormControl>
            </FormGroup>
            {/* </div>
            }))} */}

            <FormGroup row className={classes.formgroup}>
                <Button variant="contained" color="primary" type="submit" className={classes.button}>Save</Button>
                <Button href="/home" variant="contained" color="secondary" className={classes.button}>Cancel</Button>
            </FormGroup>
              
            </form>
        </Paper>
     );
}

export default Supplierdataentry;